var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubInputFollow = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 69,
  viewBox: "0 0 9 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V68",
  stroke: "#DCDFE0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 24H9",
  stroke: "#DCDFE0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 68H9",
  stroke: "#DCDFE0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubInputFollow);
export default ForwardRef;